<template>
  <v-dialog v-model="showActionTextDialog" max-width="30%" style="z-index: 999">
    <v-card min-height="20vh">
      <v-card-text class="py-12">
        <v-row justify="center">
          <p class="cb-font-size-1">
            {{actionActiveText}}
          </p>
        </v-row>
        <v-row justify="center">
          <v-progress-circular color="primary" indeterminate size="48" width="4"></v-progress-circular>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'MessageOverlayDialog',
  props: {
    showActionTextDialog: {
      type: Boolean,
      required: true
    },
    actionActiveText: {
      type: String,
      default: null

    }
  }
}
</script>

<style lang="scss" scoped>
</style>